/* COMPONENT IMPORTS*/
import { GlossaryPopup } from "../../components/Glossary/GlossaryPopup";
import { ErrorPage } from "../../components/ErrorPage/ErrorPage";
import NotificationBanner from "../../components/Notifications/NotificationBanner";
import { ReactPlugin, withAITracking } from "@microsoft/applicationinsights-react-js";
import { Highlight } from "../../components/Highlights/Highlight";
import ContextConstructor from "../../components/Context/Context";

/* MODULE IMPORTS */
import React, { Component } from "react";

/* SAME FOLDER IMPORTS*/
import SavingsNewItem from "./SavingNewItems";
import SavingNewItemsMobile from "./SavingNewItemsMobile";
import SavingsItem from "./SavingsItem";
import SavingsItemMobile from "./SavingsItemMobile";
import sendLogError from "../../sendLogError";
/* CSS IMPORT */
import "../../components/Loading/loading.css";
import "./Poupanca.css";

import poupancaImg from "../../images/poupanca.png";
import separatorImg from "../../images/separator.svg";
import loadingImg from "../../images/loading.svg";

var reactPlugin = new ReactPlugin();

class Poupanca extends Component {
  static displayName = Poupanca.name;

  constructor(props) {
    super(props);
    this.state = {
      savings: [],
      error: [],
      loading: true,
      canCreateNew: false,
    };
  }

  componentDidMount() {
    //console.log("Poupanca Context ", this.context)

    if (
      this.context.selectedUserID !== "" &&
      this.context.selectedUserID !== undefined &&
      this.context.selectedUserID !== null
    ) {
      this.populatePortfolioData();
    }
  }

  errorLoadingPortfolio() {
    return (
      <div>
        <ErrorPage />
      </div>
    );
  }

  changeValueColor(value) {
    if (value != "0.0") {
      return (
        <React.Fragment>
          <div className="table-applied">
            {new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(value)}
          </div>
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <td className="table-applied" style={{ color: "#B2B2B2" }}>
            {new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(value)}
          </td>
        </React.Fragment>
      );
    }
  }

  renderPortfolioData(state) {
    function transformActives(a) {
      if (a == "1") return a + " subscrição ativa";
      else return a + " subscrições ativas";
    }

    function getCreationArea(state) {
      if (state.canCreateNew) {
        return (
          <div>
            <div className="subscribe-text">Subscrever nova modalidade</div>
            <SavingsNewItem savingsNewList={state.savings.productTypes} />
            <SavingNewItemsMobile savingsNewList={state.savings.productTypes} />
          </div>
        );
      }
    }

    function getModalidadesArea(state) {
      if (state.savings.subscriptionsNumber > 0) {
        return (
          <div>
            <SavingsItem savingsList={state.savings.productTypes} />
            <SavingsItemMobile
              savingsList={state.savings.productTypes}
              nSavingsWithSubscriptions={state.nSavingsWithSubscriptions}
            />
          </div>
        );
      }
    }

    return (
      <main className="main">
        <NotificationBanner />
        <div className="title-bar">
          <div className="title">Poupança</div>
          <div className="title-glossary">
            <GlossaryPopup page="poupanca" />
          </div>
        </div>
        <div className="modalidades-bar">
          <div className="resumo-poupanca">
            <div className="first-div">
              <div className="table-modalidades">Modalidades</div>
              <div className="table-subscricoes">
                {transformActives(state.savings.subscriptionsNumber)}
              </div>
            </div>
            <div className="second-div">
              <div style={{ paddingRight: "10px", paddingBottom: "5px" }}>
                <img src={poupancaImg} height="48px" width="48px"></img>
              </div>
              <div>
                <div className="table-appliedtitle">Aplicados</div>
                <div>{this.changeValueColor(state.savings.totalAmounts.totalInvestedAmount)}</div>
              </div>
              <div style={{ paddingRight: "20px", paddingLeft: "20px" }}>
                <img src={separatorImg}></img>
              </div>
              <div>
                <div className="table-appliedtitle">Rendimento Bruto</div>
                {this.changeValueColor(state.savings.totalAmounts.totalReceivedAmount)}
              </div>
            </div>
            <div className="third-div">
              <div className="table-modalidades">Modalidades</div>
              <div className="table-subscricoes">
                {transformActives(state.savings.subscriptionsNumber)}
              </div>
            </div>
          </div>
        </div>
        <div className="modalidades-bar modalidades-bar-mobile">
          <div className="resumo-poupanca">
            <div className="second-div" style={{ alignItems: "center" }}>
              <div style={{ paddingRight: "10px" }}>
                <img src={poupancaImg} width="95px"></img>
              </div>
              <div style={{}}>
                <div style={{ paddingBottom: "10px" }}>
                  <div className="table-appliedtitle">Aplicados</div>
                  <div>{this.changeValueColor(state.savings.totalAmounts.totalInvestedAmount)}</div>
                </div>
                <div>
                  <div className="table-appliedtitle">Rendimento Bruto</div>
                  {this.changeValueColor(state.savings.totalAmounts.totalReceivedAmount)}
                </div>
              </div>
            </div>
            <div className="third-div">
              <div className="table-modalidades">Modalidades</div>
              <div className="table-subscricoes">
                {transformActives(state.savings.subscriptionsNumber)}
              </div>
            </div>
          </div>
        </div>
        {getModalidadesArea(state)}
        {getCreationArea(state)}
        {/* <Highlight page="poupanca" /> */}
      </main>
    );
  }

  render() {
    let contents = this.state.loading ? (
      <div className="main-page-loading">
        <div className="loading">
          <img src={loadingImg}></img>
        </div>
      </div>
    ) : this.state.error ? (
      this.errorLoadingPortfolio()
    ) : (
      this.renderPortfolioData(this.state)
    );
    return <div>{contents}</div>;
  }

  async populatePortfolioData() {
    try {
      let canCreateNew = false;
      let nSavingsWithSubscriptions = 0;

      const { idToken, selectedUserID } = this.context;

      const headers = {
        Authorization: `Bearer ${idToken}`,
        clientId: selectedUserID,
      };

      const response = await fetch("/Portfolio/GetPortfolio", { headers });

      if (!response.ok) {
        this.setState({
          savings: {},
          error: false,
          loading: false,
          canCreateNew,
          nSavingsWithSubscriptions,
        });

        return;
      }

      const data = await response.json();

      const productTypes = Array.isArray(data?.savings?.productTypes)
        ? data.savings.productTypes
        : [];

      productTypes.forEach((product) => {
        if (product.productID === "7335") {
          return; // ignora este produto
        }

        if (Number(product.subscriptionsNumber || 0) === 0) {
          canCreateNew = true;
        } else {
          nSavingsWithSubscriptions += 1;
        }
      });

      this.setState({
        savings: data?.savings || {},
        error: false,
        loading: false,
        canCreateNew,
        nSavingsWithSubscriptions,
      });

    } catch (error) {
      console.error("Error fetching portfolio:", error);

      this.setState({
        error: true,
        loading: false,
      });

      sendLogError(error.message, "populatePortfolioData");
    }
  }
}

Poupanca.contextType = ContextConstructor;

export default withAITracking(reactPlugin, Poupanca);
